var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6061 7.73661L24.3356 1.93192C24.472 1.13593 22.3116 1.38374 21.5612 1.48887C20.6971 0.955706 20.1589 -0.110616 18.4306 0.527676C16.7023 1.16597 17.8924 0.745446 16.8084 0.422545C15.7321 0.099645 14.8679 1.06084 14.8679 1.06084C14.8679 1.06084 14.3297 0.204775 13.2458 0.632806C12.1694 1.06084 12.3816 1.594 12.3816 1.594L13.8067 6.94813C10.8732 8.13461 2.91398 12.0319 0.746048 20.2772C-1.64929 29.431 5.04401 34.8227 14.072 35.5886C24.995 36.5123 29.437 30.8352 30.4603 26.0819C32.7268 15.5538 20.735 8.13461 20.5985 7.73661H20.6061ZM23.5851 20.6376H19.1356L17.3694 23.3034H23.5851V24.7978H16.8615V30.0393H14.9286V24.7978H8.2959V23.3034H14.5116L12.7455 20.6376H8.2959V19.1357H11.7373L8.87958 14.893H11.146L14.0038 19.1357H17.953L20.644 14.893H22.9105L20.1361 19.1357H23.5775V20.6376H23.5851Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkane);
export default __webpack_public_path__ + "static/media/okane.f7427ca2c34a616b757ff82c1dfdf4ca.svg";
export { ForwardRef as ReactComponent };